import {SET_SNACKBAR_CONTENT , CLOSE_SNACKBAR} from 'app/types'

const initialState = {
    open: false,
    vertical: 'bottom',
    horizontal: 'right',
    number : '0000'
}

export default function snackBarReducer (state = initialState, action) {
    switch(action.type){

        case SET_SNACKBAR_CONTENT:
            return {
                ...state,
                open : true,
                number:action.payload
            }
        case CLOSE_SNACKBAR:
            return {
                ...state,
                open : false,
            }
        default: return state
    }
}

